import logo from './logo.png';

export const settings = {
    "title": "Genius Cloud",
    "apiUrl": "https://api.guerciogiancarlo.geniuscloud.it/api",
    "ckdPath": "https://api.guerciogiancarlo.geniuscloud.it/",
    "tinyKey": "uxd8thxx2a96p0tne20wyfcdx7zvpyprm38j5q5w9qqauy2p",
    "googleMapKey": "AIzaSyDwVSRwXezXuTLG8-VAe1KfNKo7zLPlYJQ",
    //"googleMapKey": "AIzaSyB0JItfx2zvDnKkmxIBt_wru36tOVcx1iM",
    "config": {
        "limit": 50,
        "sortingField": 'id',
        "sortingOrder": 'desc'
    },
    "configEntity": {
        "customer_offer": {
            "limit": 20,
            "sortingField": 'id',
            "sortingOrder": 'desc'
        },
        "gyv_customer_offer": {
            "limit": 20,
            "sortingField": 'id',
            "sortingOrder": 'desc'
        },
        "customer_order": {
            "limit": 20,
            "sortingField": 'id',
            "sortingOrder": 'desc'
        },
        "gyv_customer_order": {
            "limit": 20,
            "sortingField": 'id',
            "sortingOrder": 'desc'
        },
        "supplier_order": {
            "limit": 20,
            "sortingField": 'id',
            "sortingOrder": 'desc'
        },
        "gyv_supplier_order": {
            "limit": 20,
            "sortingField": 'id',
            "sortingOrder": 'desc'
        },
        "customer": {
            "limit": 50,
            "sortingField": 'name',
            "sortingOrder": 'asc'
        },
        "supplier": {
            "limit": 50,
            "sortingField": 'name',
            "sortingOrder": 'asc'
        },
        "sales_agent": {
            "limit": 50,
            "sortingField": 'name',
            "sortingOrder": 'asc'
        }
    },
    "theme": {
        "siderbarIconColor": 'rgba(233,236,239,.5)'
    },
    "logo": logo,
    "data_print": {
        "name": 'Guercio Interni S.r.l.',
        "address": 'Via Marco Polo, 254 60027 Osimo (AN)',
        "phone": 'Tel: 071 716216',
        "fax": '',
        "email": 'Email: info@guerciointerni.it',
        "iva": 'P.IVA: 02813250426',
        "cf": 'C.F.: 02813250426',
        "website": 'Sito Web: www.guerciointerni.it',
    },
    "stampe" : {
       "arredatore": false, 
       "sconto": true, 
       "listino": true, 
       "condVendita": false, 
       "firmaVenditore": false
    },
    "dati_pagamento": {
        "iban": "IT17E0200837497000105563085",
        "banca": "Unicredit Spa",
        "intestatario": "Guercio Giancarlo",
    },
    "iva_label": 'esclusa',
    "iva_esclusa": true,
    "sconti": true,
    "fatturazione": false,
    "usingCache": false
    
}